import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { getFormatDate } from '../../utils/getFormatDate'

// components
import NumBox from '../../components/atom/numBox/NumBox'
import BoxShadow from '../../components/atom/boxShadow/BoxShadow'
import DropDown from '../../components/dropdown/DropDown'
import {
  HeaderTab,
  Period,
  Selector,
  Summary,
  CalendarModal,
} from '../../components'
import QuarterlySelectionModal from '../../components/modal/QuarterlySelectionModal'

// styles
import colors from '../../styles/colors'

// images
import SearchIconBtn from '../../components/atom/searchBtn/SearchIconBtn'
import Button from '../../components/atom/button/Button'
import IconDown from '../../assets/image/arrow/ic-down.svg'
import { getComma } from '../../utils/getComma'

const RIGHT_FIRST_ITEM = ['접수\n/요청', '요청\n ', '접수\n ']
const RIGHT_SECOND_ITEM = ['배정\n/준비중', '배정', '준비중']
const RIGHT_THIRD_ITEM = ['배달중\n/픽업대기', '배달중', '픽업대기']
const RIGHT_FOURTH_ITEM = ['주문\n완료', '배달완료', '픽업완료']
const RIGHT_FIFTH_ITEM = ['주문\n취소', '배달취소', '픽업취소']

// [ 당일, 기간별에 따라서 주문현황 테이블 위에 박스 ]
const OrderDateBox = ({
  orderDate,
  setSend,
  data,
  orderNum,
  isMobile,
  type, // undefined: 전체, D: 배달, P: 픽업
}) => {
  const navigate = useNavigate()

  // calendar select
  // 디폴트 오늘 -> 30일
  const [startDate, setStartDate] = useState(
    orderDate === 'today'
      ? moment().format('YYYY-MM-DD')
      : moment().subtract(30, 'd').format('YYYY-MM-DD'),
  )
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
  const TODAY_PERIOD_ITEM = [
    { name: '오늘', action: () => console.log('$$ 오늘') },
  ]
  const SELELCT_PERIOD_ITEM = [
    { name: '오늘', action: () => console.log('$$ 오늘') },
    { name: '이번주', action: () => console.log('$$ 이번주') },
    { name: '30일', action: () => console.log('$$ 30일') },
    { name: '분기', action: () => console.log('$$ 분기') },
    { name: '날짜', action: () => console.log('$$ 날짜') },
  ]
  // 디폴트 오늘 -> 30일
  const [selectedIndex, setSelectedIndex] = useState(
    orderDate === 'today' ? 0 : 2,
  )
  const [isQuarterVisibleModal, setIsQuarterVisibleModal] = useState(false)
  const [isCalVisibleModal, setIsCalVisibleModal] = useState(false)

  // calendar
  const daysOffSetting = false
  const [rangeDates, setRangeDates] = useState([])
  const defaultSelected = {
    to: '',
    from: '',
  }
  const [range, setRange] = useState(defaultSelected)
  const [isChangeCal, setIsChangeCal] = useState(false)

  // 요약 문구
  const [summaryItem, setSummaryItem] = useState({
    type: '', // 주문유형
    detail: '', // 상세유형
    state: '', // 주문상태
    delivery: '', // 배달상태
  })
  // search
  const [searchInput, setSearchInput] = useState(orderNum ? orderNum : '')

  // search 기능
  const handleInputChange = (event) => {
    const inputValue = event.target.value

    // 특수문자X 한글
    if (!/[^a-zA-Z0-9가-힣\s]/.test(inputValue)) {
      setSearchInput(inputValue)
    }
  }

  const setToday = () => {
    handleDateTab(selectedIndex)
    setStartDate(moment().format('YYYY-MM-DD'))
    setEndDate(moment().format('YYYY-MM-DD'))
  }

  const handleDateTab = (flag) => {
    setSelectedIndex(flag)

    if (flag !== 3) {
      setIsChangeCal(false)
      setRange(defaultSelected)
    }
  }

  const selectRangeDate = () => {
    const startMoment = moment(moment(range?.from).format('YYYY-MM-DD'))
    const endMoment = moment(moment(range?.to).format('YYYY-MM-DD'))

    //시작날짜 ~ 종료날짜가 1년인지 확인
    const isWithinOneYear = endMoment.diff(startMoment, 'years') < 1

    //시작, 종료 날짜가 1년
    const isStartBeforeOneYearAgo = startMoment.isBefore(
      moment().subtract(1, 'year'),
    )
    const isEndBeforeOneYearAgo = endMoment.isBefore(
      moment().subtract(1, 'year'),
    )

    // 아무것도 선택 안한 경우
    if (!range?.to && !range?.from) return setIsCalVisibleModal(false)
    // 하나만 선택
    else if (!range?.to && range?.from) {
      if (
        !isWithinOneYear ||
        isStartBeforeOneYearAgo ||
        isEndBeforeOneYearAgo
      ) {
        alert('오늘로부터 1년간의 기간만 조회가 가능합니다.')
        return
      } else {
        setStartDate(range.from)
        setEndDate(range.from)
      }
    }

    // 모두 선택
    if (getFormatDate(range.from) && getFormatDate(range.to)) {
      // 기간 제한(시작 ~ 종료: 1년)
      if (
        !isWithinOneYear ||
        isStartBeforeOneYearAgo ||
        isEndBeforeOneYearAgo
      ) {
        alert('오늘로부터 1년간의 기간만 조회가 가능합니다.')
        return
      } else {
        setStartDate(range.from)
        setEndDate(range.to)
        setSelectedIndex(4)
        setIsChangeCal(true)
      }
    }

    setIsCalVisibleModal(false)
  }

  const handleSetModal = () => {
    if (selectedIndex === 3) {
      setIsQuarterVisibleModal(true)
    } else {
      // 디폴트 날짜 세팅
      setRange({
        from: new Date(startDate),
        to: new Date(endDate),
      })

      setIsCalVisibleModal(true)
    }
  }

  const selectQuarter = (start, end) => {
    setIsQuarterVisibleModal(false)

    if (getFormatDate(start) && getFormatDate(end)) {
      setStartDate(moment(start, 'YYYY년 MM월 DD일').format('YYYY-MM-DD'))
      setEndDate(moment(end, 'YYYY년 MM월 DD일').format('YYYY-MM-DD'))
    }
  }

  useEffect(() => {
    if (selectedIndex === 4 && !isChangeCal) {
      // 디폴트 날짜 세팅
      setRange({
        from: new Date(startDate),
        to: new Date(endDate),
      })

      // setIsCalVisibleModal(true)
    }
    // if (selectedIndex === 3) {
    //   setIsQuarterVisibleModal(true)
    // } else if (selectedIndex === 4 && !isChangeCal) {
    //   // 디폴트 날짜 세팅
    //   setRange({
    //     from: new Date(startDate),
    //     to: new Date(endDate),
    //   })

    //   setIsCalVisibleModal(true)
    // }
  }, [selectedIndex])

  // < filter dropdown 항목>
  // 1) 주문유형
  const typeobj = {
    100: '주문유형 전체',
    D: '배달',
    P: '픽업',
  }
  const [orderType, setOrderType] = useState('전체')

  // 2) 상세유형
  const detailobj = {
    100: '상세유형 전체',
    O: '즉시주문',
    G: '예약주문',
    C: '드라이브픽업',
    R: '사전예약',
  }
  const [orderDetail, setOrderDetail] = useState('전체')

  // 3) 주문상태
  const stateobj = {
    100: '주문상태 전체',
    301: '주문접수',
    302: '상품준비중',
    303: '상품준비완료(배달)',
    304: '상품준비완료(픽업)',
    305: '주문완료',
    306: '주문거절',
    307: '주문취소',
    // 308: '자체배달',
  }
  const [orderState, setOrderState] = useState('전체')

  // 4) 배달상태
  const deliveryobj = {
    100: '배달상태 전체',
    401: '배달요청',
    402: '배달접수',
    403: '배달중',
    404: '배달완료',
    405: '배달불가',
    406: '배달취소',
    411: '픽업완료',
  }
  const [orderDelivery, setOrderDelivery] = useState('전체')

  // 조회 버튼 클릭(setSend props)
  const handleSearchClick = () => {
    const selectedValues = {}

    // startDate와 endDate 값이 있는 경우에만 추가
    if (startDate && endDate) {
      selectedValues.startDate = moment(startDate).format('YYYY-MM-DD')
      selectedValues.endDate = moment(endDate).format('YYYY-MM-DD')
    }

    const fields = ['orderType', 'orderDetail', 'orderState', 'orderDelivery']

    fields.forEach((field) => {
      if (
        eval(field) !== '100' &&
        eval(field) !== '전체'
        // eval(field) !== '전체' &&
        // eval(field) !== '300' &&
        // eval(field) !== '400'
      ) {
        selectedValues[field] = eval(field)
      }
    })

    if (searchInput !== '') {
      selectedValues.orderNum = searchInput
    }

    setSummaryItem({
      type: orderType, // 주문유형
      detail: orderDetail, // 상세유형
      state: orderState, // 주문상태
      delivery: orderDelivery, // 배달상태
    })

    setSend(selectedValues)
  }

  const getSummaryTitle = (orderState) => {
    if (!orderState) return '결제금액'

    switch (orderState) {
      case '306':
        return '주문거절금액'

      case '307':
        return '주문취소금액'

      default:
        return '결제금액'
    }
  }

  const handlePeriodItem = (flag) => {
    switch (flag) {
      case 0:
      case 1:
      case 2:
        setSelectedIndex(flag)
        break

      case 3:
        setIsQuarterVisibleModal(true)
        setSelectedIndex(flag)
        break

      case 4:
        setIsChangeCal(false)
        setIsCalVisibleModal(true)
        setSelectedIndex(flag)
        break

      default:
        break
    }
  }

  const summaryItemPrint = (flag, orderType) => {
    let text = ''
    // undefined 전체
    // D 배달
    // P 픽업
    let statusType = !orderType ? 0 : orderType === 'D' ? 1 : 2

    switch (flag) {
      case 0:
        text = RIGHT_FIRST_ITEM[statusType]
        break

      case 1:
        text = RIGHT_SECOND_ITEM[statusType]
        break

      case 2:
        text = RIGHT_THIRD_ITEM[statusType]
        break

      case 3:
        text = RIGHT_FOURTH_ITEM[statusType]
        break

      case 4:
        text = RIGHT_FIFTH_ITEM[statusType]
        break

      default:
        break
    }

    return text
  }

  // console.log('$$ order box', type)

  return (
    <>
      <Period
        periodItem={
          orderDate === 'today' ? TODAY_PERIOD_ITEM : SELELCT_PERIOD_ITEM
        }
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        handleSetModal={orderDate === 'today' ? null : handleSetModal}
        selectedIndex={selectedIndex}
        setSelectedIndex={handlePeriodItem}
        // setSelectedIndex={setSelectedIndex}
        maxWidth={984}
      >
        <DropDownBox>
          <DropDown
            defaultOption={'주문유형'}
            options={Object.values(typeobj)}
            setOption={(selectedValue) => {
              const selectedKey = Object.keys(typeobj).find(
                (key) => typeobj[key] === selectedValue,
              )

              setOrderType(selectedKey)
            }}
            value={typeobj[orderType]}
          />
          <DropDown
            defaultOption={'상세유형'}
            options={Object.values(detailobj)}
            setOption={(selectedValue) => {
              const selectedKey = Object.keys(detailobj).find(
                (key) => detailobj[key] === selectedValue,
              )
              setOrderDetail(selectedKey)
            }}
            value={detailobj[orderDetail]}
          />
          <DropDown
            defaultOption={'주문상태'}
            options={Object.values(stateobj)}
            setOption={(selectedValue) => {
              const selectedKey = Object.keys(stateobj).find(
                (key) => stateobj[key] === selectedValue,
              )
              setOrderState(selectedKey)
            }}
            value={stateobj[orderState]}
          />
          <DropDown
            defaultOption={'배달상태'}
            options={Object.values(deliveryobj)}
            setOption={(selectedValue) => {
              const selectedKey = Object.keys(deliveryobj).find(
                (key) => deliveryobj[key] === selectedValue,
              )
              setOrderDelivery(selectedKey)
            }}
            value={deliveryobj[orderDelivery]}
          />
          {orderDate !== 'today' && (
            <SearchIconBtn onClick={handleSearchClick} />
          )}
        </DropDownBox>
        {orderDate === 'today' && (
          <SearchInputWrap>
            <SearchInputBox>
              <input
                type="text"
                placeholder="주문번호를 입력해주세요."
                value={searchInput}
                onChange={handleInputChange}
              />
            </SearchInputBox>
            <SearchIconBtn onClick={handleSearchClick} />
          </SearchInputWrap>
        )}
        <SearchBtn>
          <Button onClick={handleSearchClick}>조회</Button>
        </SearchBtn>
      </Period>
      {orderDate === 'today' ? (
        <Summary
          singleStat={false}
          // titleLabel={`금일 ${getSummaryTitle(summaryItem?.state)}`}
          titleLabel={'금일 결제금액'}
          titleStat={
            data && data?.resultCode !== '1003'
              ? getComma(data?.totalPrice) + '원'
              : '0원'
          }
        />
      ) : (
        <Summary
          singleStat={false}
          // titleLabel={getSummaryTitle(summaryItem?.state)}
          titleLabel={'결제금액'}
          titleStat={
            data && data?.resultCode !== '1003'
              ? getComma(data?.totalPrice) + '원'
              : '0원'
          }
        />
      )}
      {/* 당일 주문현황 */}
      {orderDate === 'today' ? (
        <BoxShadow
          className="boxShadow"
          maxWidth={984}
          paddingVertical={!isMobile ? 23 : 30}
          paddingHorizontal={!isMobile ? 33 : 20}
        >
          <SummaryWrapper>
            <LeftSummary>
              <MainTitle>전체</MainTitle>
              <Contents>
                <span>{getComma(data?.totalCount)}</span>
                <span>&nbsp;건</span>
              </Contents>
            </LeftSummary>
            <DivideLine />
            <CenterSummary>
              <MainTitle>주문 상태</MainTitle>
              <ItemWrapper>
                <Item>
                  <SubTitle>{`주문\n접수`}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.receiptStateCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{`상품\n준비중`}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.productStateCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{`배달/픽업\n준비중`}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.deliveryStateCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{`완료`}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.completeStateCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>
              </ItemWrapper>
            </CenterSummary>
            <DivideLine />
            {/* type에 따라 표시 변경 */}
            <RightSummary>
              <MainTitle>주문 현황</MainTitle>
              <ItemWrapper>
                <Item>
                  <SubTitle>{summaryItemPrint(0, type)}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.receiptProgressCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{summaryItemPrint(1, type)}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.assignProgressCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{summaryItemPrint(2, type)}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.deliveryProgressCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{summaryItemPrint(3, type)}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.completeProgressCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>

                <Item>
                  <SubTitle>{summaryItemPrint(4, type)}</SubTitle>
                  <Contents>
                    <span>{getComma(data?.cancelProgressCount)}</span>
                    <span>&nbsp;건</span>
                  </Contents>
                </Item>
              </ItemWrapper>
            </RightSummary>
          </SummaryWrapper>

          {/* <StateWrap className="borderR">
            <h4 className="mb-4 fs-6 fw-bold">주문유형</h4>
            <StateBox>
              <NumBox
                title={'전체'}
                num={
                  data?.resultData.totalCount !== undefined
                    ? getComma(data?.resultData.totalCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'요청'}
                num={
                  data?.resultData.requestCount !== undefined
                    ? getComma(data?.resultData.requestCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'배정'}
                num={
                  data?.resultData.asignCount !== undefined
                    ? getComma(data?.resultData.asignCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'픽업'}
                num={
                  data?.resultData.pickupCount !== undefined
                    ? getComma(data?.resultData.pickupCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'취소'}
                num={
                  data?.resultData.cancelCount !== undefined
                    ? getComma(data?.resultData.cancelCount)
                    : '0'
                }
                unit={'개'}
              />
            </StateBox>
          </StateWrap>
          <BorderLine />
          <StateWrap>
            <h4 className="mb-4 fs-6 fw-bold">주문상태</h4>
            <StateBox>
              <NumBox
                className="col"
                title={'전체'}
                num={
                  data?.resultData.acceptCount !== undefined
                    ? getComma(data?.resultData.acceptCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'상품준비중'}
                num={
                  data?.resultData.prepareCount !== undefined
                    ? getComma(data?.resultData.prepareCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'준비완료'}
                num={
                  data?.resultData.readyCount !== undefined
                    ? getComma(data?.resultData.readyCount)
                    : '0'
                }
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'배달완료'}
                num={
                  data?.resultData.deliveryCount !== undefined
                    ? getComma(data?.resultData.deliveryCount)
                    : '0'
                }
                unit={'개'}
              />
            </StateBox>
          </StateWrap> */}
        </BoxShadow>
      ) : (
        // 기간별 주문현황
        <BoxShadow className="boxShadow" maxWidth={984}>
          <StateWrap className="borderR">
            <h4 className="mb-4 fs-6 fw-bold">주문상태</h4>
            <SelectStateBox>
              <div className="selectTopCount">
                <NumBox
                  mainTitle={'전체주문'}
                  title={''}
                  num={
                    data?.totalCount !== undefined
                      ? getComma(data?.totalCount)
                      : '-'
                  }
                  unit={'건'}
                  className={'empty-text-effect'}
                />
              </div>
              <div className="borderLine"></div>
              <div className="selectBotCount">
                <NumBox
                  mainTitle={'주문유형'}
                  title={
                    typeobj[summaryItem.type] !== '주문유형 전체' &&
                    typeobj[summaryItem.type] !== undefined
                      ? typeobj[summaryItem.type]
                      : '전체'
                  }
                  num={
                    summaryItem.type === '' || summaryItem.type === '전체'
                      ? '-'
                      : data?.orderTypeCount !== undefined
                      ? getComma(data?.orderTypeCount)
                      : data?.totalCount !== undefined
                      ? getComma(data?.totalCount)
                      : '-'
                  }
                  unit={'건'}
                />
                <NumBox
                  mainTitle={'상세유형'}
                  title={
                    detailobj[summaryItem.detail] !== '상세유형 전체' &&
                    detailobj[summaryItem.detail] !== undefined
                      ? detailobj[summaryItem.detail]
                      : '전체'
                  }
                  num={
                    summaryItem.detail === '' || summaryItem.detail === '전체'
                      ? '-'
                      : data?.orderDetailCount !== undefined
                      ? getComma(data?.orderDetailCount)
                      : data?.totalCount !== undefined
                      ? getComma(data?.totalCount)
                      : '-'
                  }
                  unit={'건'}
                />

                <NumBox
                  mainTitle={'주문상태'}
                  title={
                    stateobj[summaryItem.state]
                      ? summaryItem.state === '100'
                        ? '전체'
                        : stateobj[summaryItem.state]
                      : '전체'
                  }
                  num={
                    summaryItem.state === '' || summaryItem.state === '전체'
                      ? '-'
                      : data?.orderStatusCount !== undefined
                      ? getComma(data?.orderStatusCount)
                      : data?.totalCount !== undefined
                      ? getComma(data?.totalCount)
                      : '-'
                  }
                  unit={'건'}
                />
                <NumBox
                  mainTitle={'배달상태'}
                  title={
                    deliveryobj[summaryItem.delivery]
                      ? summaryItem.delivery === '100'
                        ? '전체'
                        : deliveryobj[summaryItem.delivery]
                      : '전체'
                  }
                  num={
                    summaryItem.delivery === '' ||
                    summaryItem.delivery === '전체'
                      ? '-'
                      : data?.deliveryStatusCount !== undefined
                      ? getComma(data?.deliveryStatusCount)
                      : data?.totalCount !== undefined
                      ? getComma(data?.totalCount)
                      : '-'
                  }
                  unit={'건'}
                />
              </div>
            </SelectStateBox>
          </StateWrap>
        </BoxShadow>
      )}
      <CalendarModal
        title={'날짜'}
        show={isCalVisibleModal}
        handleClose={() => {
          setIsCalVisibleModal(false)
          // setToday()
        }}
        handleSubmit={selectRangeDate}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        range={range}
        setRange={setRange}
        rangeDates={rangeDates}
        setRangeDates={setRangeDates}
        daysOffSetting={daysOffSetting}
      />

      <QuarterlySelectionModal
        show={isQuarterVisibleModal}
        handleClose={() => {
          setIsQuarterVisibleModal(false)
          // setToday()
        }}
        handleSubmit={selectQuarter}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        endDate={endDate}
        title={'분기'}
      />
    </>
  )
}
export default OrderDateBox

const DropDownBox = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

const StateWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }
`
const BorderLine = styled.p`
  width: 1px;
  height: 100%;
  background-color: #f3f3f3;
  margin: 0px 5% 0px 5%;
`
// 당일
const StateBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  /* gap: 40px; */
  /* margin-left: 20px; */

  @media screen and (max-width: 800px) {
    /* gap: 50px; */
  }
  @media screen and (max-width: 480px) {
    /* gap: 20px; */
  }
`
// 기간별
const SelectStateBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* gap: 50px; */
  /* margin-left: 20px; */
  @media screen and (max-width: 800px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* gap: 50px; */
  }
  .selectTopCount {
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .selectBotCount {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (max-width: 800px) {
    gap: 19px;
    .borderLine {
      width: 100%;
      height: 1px;
      border-top: 1px solid #f3f3f3;
    }
  }
`

const SearchBtn = styled.div`
  display: none;
  margin-top: 16px;
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    display: block;
  }
`
const SearchInputWrap = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  h4 {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  @media ${(props) => props.theme.mobile}, ${(props) => props.theme.tablet} {
    display: flex;
    flex-direction: column;
  }
`

const SearchInputBox = styled.div`
  border-radius: 8px;
  border: solid 1px #e5e5e5;
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  input {
    width: 100%;
    padding: 15px;
    color: #000;
    font-size: 16px;
  }
`

const SummaryWrapper = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`

const LeftSummary = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-right: 33px;

  @media (max-width: 800px) {
    padding-right: 0;
    padding-left: 8px;
    align-items: flex-start;
  }
`

const CenterSummary = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 25px;
  flex: 1;

  @media (max-width: 800px) {
    padding: 0;
    align-items: flex-start;
  }
`

const RightSummary = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 25px;
  flex: 1;

  @media (max-width: 800px) {
    padding: 0;
    align-items: flex-start;
  }
`

const MainTitle = styled.div`
  color: ${colors.BK};
  font-weight: 700;

  @media (max-width: 800px) {
    font-size: 14px;
    margin-bottom: 14px;
  }
`

const SubTitle = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
  color: ${colors.BK};
  white-space: pre-wrap;
  line-height: normal;
  text-align: center;

  @media (max-width: 800px) {
    margin-top: 0;
    font-size: 13px;
    margin-bottom: 4px;
    line-height: 1.5;
  }
`

const Contents = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.BK};

  span:nth-child(1) {
    font-size: 22px;
    font-weight: 700;

    @media (max-width: 800px) {
      font-size: 20px;
    }
  }

  span:nth-child(2) {
    font-size: 14px;
  }

  @media (max-width: 800px) {
    margin-top: 8px;
  }
`

const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    width: 100%;
    padding: 0 4px;
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

const DivideLine = styled.div`
  width: 1px;
  background-color: #dedede;

  @media (max-width: 800px) {
    width: 100%;
    height: 1px;
    background-color: #e6e6e6;
    margin: 22px 0;
  }
`
